export default "__VITE_ASSET__91fe4e21__"